<ng-container *ngIf="authenticated">
    <ng-container *ngIf="!isAdmin">
        <div class="app">
            <div class="app-container">
                <app-sidebar *ngIf="!router.url.includes('qrcode')" [hidden] = "userInformationAPIIsLoading"></app-sidebar>
                <div class="app-data" id="top">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="isAdmin">
        <app-admin-printos-header *ngIf="isAdmin"></app-admin-printos-header>
        <router-outlet></router-outlet>
     </ng-container>

</ng-container>
    
    <div class="loader-wrapper" *ngIf="!authenticated" >
        <div class="spinner tp" >
            <mat-spinner [diameter] = "45"></mat-spinner>
        </div>
    </div>
    